// Custom Scripts Bundle - Local JavaScript files
// This replaces individual <script> tags for local JS files

// Core functionality - always needed
import './js/main.js';

// Services section functionality
import './js/services-variant-6.js';

// Agenda page functionality  
import './js/agenda.js';

// Optional: Uncommented JS files can be added here
// import '../assets/js/animated.headline.js';
// import '../assets/js/jquery.barfiller.js';
// import '../assets/js/plugins.js';

// Log successful bundle load
console.log('✅ Custom scripts bundle loaded');
